var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('button',{staticClass:"AlgoliaSearchClear flex-center",class:{ 'is-active': !_vm.state.hasRefinements },on:{"click":_vm.onRefine}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }